import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

const CONTINUE_TEXT = "Continue to External Web Site";
const CANCEL_TEXT = "Cancel";

class ExternalLinkModal extends React.Component {
    static propTypes = {
        shouldPresent: PropTypes.bool,
        onCancel: PropTypes.func.isRequired,
        onContinue: PropTypes.func.isRequired
    };

    static defaultProps = {
        shouldPresent: false
    };

    render() {
        return (
            <div>
                <Modal
                    isOpen={this.props.shouldPresent}
                    onRequestClose={this.onModalCancel}
                    role="complementary"
                    className={{
                        base: "rec-modal-dialog-base",
                        afterOpen: "rec-modal-dialog-after-open-md",
                        beforeClose: "rec-modal-dialog-before-close"
                    }}
                    overlayClassName={{
                        base: "rec-overlay-base",
                        afterOpen: "rec-overlay-after-open",
                        beforeClose: "rec-overlay-before-close"
                    }}
                    contentLabel="You are exiting Recreation.gov"
                    ariaHideApp={false}>
                    <div>
                        <div className="rec-modal-content-wrap">
                            <h4 className="rec-modal-title">You are leaving Recreation.gov</h4>
                            <div>
                                You are leaving the <a href="https://www.recreation.gov">Recreation.gov</a> website and
                                entering an external or third-party site.&nbsp;
                                <a href="https://www.recreation.gov">Recreation.gov</a> has provided this link because
                                it contains relevant information that may be useful or interesting.&nbsp;
                                <a href="https://www.recreation.gov">Recreation.gov</a> has provided these external links
                                for reference only and cannot attest to the accuracy of information provided by
                                third-party sites or any other linked site outside the control of&nbsp;
                                <a href="https://www.recreation.gov">Recreation.gov</a>.
                            </div>
                        </div>
                        <div className="rec-modal-actions-wrap">
                            <button className="rec-button-tertiary" title={CANCEL_TEXT} aria-label={CANCEL_TEXT} onClick={this.props.onCancel}>
                                {CANCEL_TEXT}
                            </button>
                            <button className="rec-button-primary" title={CONTINUE_TEXT} aria-label={CONTINUE_TEXT} onClick={this.props.onContinue}>
                                {CONTINUE_TEXT}
                            </button>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default ExternalLinkModal;
